import React from "react";

const ExportButton = ({ onClick, loading = false, disabled = false }) => {
    return(
        <div 
            className={`flex items-center border-[1px] border-[#E5E7EB] rounded-lg justify-center px-4 p-2 
                ${disabled || loading ? 'opacity-50 cursor-not-allowed bg-gray-100' : 'hover:bg-gray-100 cursor-pointer '}`} 
            onClick={!disabled && !loading ? onClick : undefined}
        >
            <p className="font-itcmedium text-sm text-[#1F2A37]">
                {loading ? 'Exportando...' : 'Exportar'}
            </p>
            {loading && (
                <svg className="animate-spin ml-2 h-4 w-4 text-[#1F2A37]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            )}
        </div>
    );
};

export default ExportButton;